<div [formGroup]="formGroup">
  <sc-string-field labelDictionaryKey="tmc-yard.entity.transport.masterdata.string2" formControlName="value"></sc-string-field>
</div>
